type EnvType = {
  VITE_API_URL: string;
  VITE_APP_VERSION: string;
  VITE_GOOGLE_API_KEY: string;
  VITE_HASHED_ALPHA_PASSWORD: string;
  VITE_RUDDERSTACK_DATA_PLANE_URL: string;
  VITE_RUDDERSTACK_WRITE_KEY: string;
  VITE_RUDDERSTACK_CONTROL_PLANE_URL: string;
  VITE_SENTRY_DSN: string;
  VITE_APP_ENV: string;
  VITE_DATADOG_APPLICATION_ID: string;
  VITE_DATADOG_CLIENT_TOKEN: string;
  VITE_DATADOG_SITE: string;
};

export const env: EnvType = { ...import.meta.env, ...window['env'] };

declare global {
  interface Window {
    env: EnvType & unknown;
  }
}

export const isDev = () => import.meta.env.DEV === true;
export const isTest = () => import.meta.env.MODE === 'test';
export const getBaseUrl = () => (isDev() ? '/api' : env.VITE_API_URL);
export const appVersion = env.VITE_APP_VERSION ?? 'dev';
export const hashedAlphaPassword = env.VITE_HASHED_ALPHA_PASSWORD;
export const sentryDsn = env.VITE_SENTRY_DSN;
